export const getSessionId = (): Promise<{ sessionId: string | null }> => {
  const id = window.mParticle.sessionManager.getSession();
  return Promise.resolve({ sessionId: id });
};
